import React, { Fragment } from 'react';
import { graphql } from 'gatsby';

export default function Page (props) {
  return <Fragment {...props} />;
}

export const getPageElements = ({ acf: { htmls, strings, images } }) =>
  Object.assign({},
    ...(htmls || []).map(({ label, body }) => ({ [label]: body })),
    ...(strings || []).map(({ label, text }) => ({ [label]: text })),
    ...(images || []).map(({ label, image }) => ({ [label]: image }))
  );

export const query = graphql`
  fragment Page on wordpress__wp_websites {
    acf {
      title
      slug
      htmls {
        label
        body
      }
      strings {
        label
        text
      }
      images {
        label
        image {
          localFile {
            sharp: childImageSharp {
              fluid {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`;